/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: cGVJnrZBpZGCmuty7FxDYj
// Component: dupS_YkyICcu
import * as React from "react";
import {
  PlasmicLink as PlasmicLink__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import PageLayout from "../../PageLayout"; // plasmic-import: uyj0PXLvMOqU/component
import Container from "../../Container"; // plasmic-import: D1maE2RgYRQ-/component
import Disclaimer from "../../Disclaimer"; // plasmic-import: 3Ntynz3mbk3J/component
import Footer from "../../Footer"; // plasmic-import: -uu8Ke8fb9WQ/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: cGVJnrZBpZGCmuty7FxDYj/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: cGVJnrZBpZGCmuty7FxDYj/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic.module.css"; // plasmic-import: cGVJnrZBpZGCmuty7FxDYj/projectcss
import sty from "./PlasmicTeam.module.css"; // plasmic-import: dupS_YkyICcu/css

createPlasmicElementProxy;

export const PlasmicTeam__VariantProps = new Array();

export const PlasmicTeam__ArgProps = new Array("onClick2");

const $$ = {};

function PlasmicTeam__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const globalVariants = _useGlobalVariants();
  const styleTokensClassNames = _useStyleTokens();
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"pageHome"}
          data-plasmic-override={overrides.pageHome}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            styleTokensClassNames,
            sty.pageHome
          )}
        >
          <div
            data-plasmic-name={"sidebar"}
            data-plasmic-override={overrides.sidebar}
            className={classNames(projectcss.all, sty.sidebar)}
          >
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__pdsVi
              )}
            >
              <React.Fragment>
                <React.Fragment>{"[ "}</React.Fragment>
                {
                  <PlasmicLink__
                    className={classNames(
                      projectcss.all,
                      projectcss.a,
                      projectcss.__wab_text,
                      projectcss.plasmic_default__inline,
                      sty.link__uVtp
                    )}
                    href={"https://o21p.com/"}
                    platform={"react"}
                  >
                    {"o21p"}
                  </PlasmicLink__>
                }
                <React.Fragment>{" | "}</React.Fragment>
                {
                  <PlasmicLink__
                    className={classNames(
                      projectcss.all,
                      projectcss.a,
                      projectcss.__wab_text,
                      projectcss.plasmic_default__inline,
                      sty.link__tGaox
                    )}
                    href={`/`}
                    platform={"react"}
                  >
                    {"team"}
                  </PlasmicLink__>
                }
                <React.Fragment>{" ]"}</React.Fragment>
              </React.Fragment>
            </div>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__ygvTv
              )}
            >
              <React.Fragment>
                <React.Fragment>{"[ "}</React.Fragment>
                {
                  <PlasmicLink__
                    className={classNames(
                      projectcss.all,
                      projectcss.a,
                      projectcss.__wab_text,
                      projectcss.plasmic_default__inline,
                      sty.link__g8Llp
                    )}
                    href={`/cause`}
                    platform={"react"}
                  >
                    {"cause"}
                  </PlasmicLink__>
                }
                <React.Fragment>{" ]"}</React.Fragment>
              </React.Fragment>
            </div>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__kRzas
              )}
            >
              <React.Fragment>
                <React.Fragment>{"[ "}</React.Fragment>
                {
                  <PlasmicLink__
                    className={classNames(
                      projectcss.all,
                      projectcss.a,
                      projectcss.__wab_text,
                      projectcss.plasmic_default__inline,
                      sty.link___6N3Bp
                    )}
                    href={`/the-system-we-build-ourselves`}
                    platform={"react"}
                  >
                    {"our worldview"}
                  </PlasmicLink__>
                }
                <React.Fragment>{" ]"}</React.Fragment>
              </React.Fragment>
            </div>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__wiZs5
              )}
            >
              <React.Fragment>
                <React.Fragment>{"[ "}</React.Fragment>
                {
                  <PlasmicLink__
                    className={classNames(
                      projectcss.all,
                      projectcss.a,
                      projectcss.__wab_text,
                      projectcss.plasmic_default__inline,
                      sty.link___2GxOu
                    )}
                    href={`/the-independent`}
                    platform={"react"}
                  >
                    {"the independent"}
                  </PlasmicLink__>
                }
                <React.Fragment>{" ]"}</React.Fragment>
              </React.Fragment>
            </div>
          </div>
          <PageLayout
            data-plasmic-name={"pageLayout"}
            data-plasmic-override={overrides.pageLayout}
            className={classNames("__wab_instance", sty.pageLayout)}
            content={
              <React.Fragment>
                <section
                  data-plasmic-name={"s00"}
                  data-plasmic-override={overrides.s00}
                  className={classNames(projectcss.all, sty.s00)}
                >
                  <Container
                    className={classNames(
                      "__wab_instance",
                      sty.container__jqpQ7
                    )}
                    colContent={
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text__nvCBr
                        )}
                      >
                        {"the o21p team."}
                      </div>
                    }
                    width={"medium"}
                  />
                </section>
                <section
                  data-plasmic-name={"s1"}
                  data-plasmic-override={overrides.s1}
                  className={classNames(projectcss.all, sty.s1)}
                >
                  <Container
                    className={classNames(
                      "__wab_instance",
                      sty.container__xxTii
                    )}
                    colContent={
                      <div
                        data-plasmic-name={"freeBox"}
                        data-plasmic-override={overrides.freeBox}
                        className={classNames(projectcss.all, sty.freeBox)}
                      >
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p___640Rl
                          )}
                        >
                          {"Dear future teammate,"}
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__yEU7
                          )}
                        >
                          {
                            "I\u2019ll try my best to make this NOT sound like a 3 a.m. diary entry after learning about systems."
                          }
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__d5ThG
                          )}
                        >
                          {"I hope you like to read."}
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p___2E3LS
                          )}
                        >
                          {
                            "There are no pictures. Our part-time graphic designer is currently buried inside the Figma variables panel."
                          }
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__jDaOl
                          )}
                        >
                          {"Alright..."}
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__zJxkE
                          )}
                        >
                          {"*clears throat*"}
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__pRbd7
                          )}
                        >
                          {"As Steve Jobs once said:"}
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__ioXcd
                          )}
                        >
                          {
                            "\u201c...this is a very complicated world, it\u2019s a very noisy world and we\u2019re not going to get the chance to get people to remember much about us. No company is. So we have to be really clear on what we want them to know about us.\u201d"
                          }
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__loL9E
                          )}
                        >
                          {"What we want people to know about us is this:"}
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__fZhKy
                          )}
                        >
                          {
                            "o21p exists because we believe individuals should be able to live and work on their own terms, without being swallowed by the systems around them."
                          }
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__aYNhK
                          )}
                        >
                          <React.Fragment>
                            <React.Fragment>
                              {
                                "We use technology to help individuals build systems around their work and life that extend what they can do in an increasingly complex world. We call those systems "
                              }
                            </React.Fragment>
                            <span
                              className={
                                "plasmic_default__all plasmic_default__span"
                              }
                              style={{ textDecorationLine: "underline" }}
                            >
                              {"personal systems."}
                            </span>
                          </React.Fragment>
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__tev07
                          )}
                        >
                          {
                            "We\u2019re building the infrastructure that makes these personal systems possible."
                          }
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p___7WI7E
                          )}
                        >
                          <React.Fragment>
                            <React.Fragment>
                              {
                                "The reason we do what we do stems from our belief that "
                              }
                            </React.Fragment>
                            <span
                              className={
                                "plasmic_default__all plasmic_default__span"
                              }
                              style={{ textDecorationLine: "underline" }}
                            >
                              {
                                "autonomy is the foundation of meaningful human action."
                              }
                            </span>
                          </React.Fragment>
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__gGttR
                          )}
                        >
                          {
                            "As society scales, a gap opens up between the rising complexity of systems and the fixed capacity of one person to manage them."
                          }
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__jYiW9
                          )}
                        >
                          {"That gap..."}
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__tur6Z
                          )}
                        >
                          {
                            "That misalignment is what turns the pressure on autonomy and identity into an existential threat for the individual."
                          }
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__j0Mtn
                          )}
                        >
                          {"Burnout."}
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__cExf7
                          )}
                        >
                          {"Numbness."}
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__wtULo
                          )}
                        >
                          {"Disengagement."}
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p___9MoJ
                          )}
                        >
                          {
                            "The sense that it doesn\u2019t really matter whether you do the work or someone else does."
                          }
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__i2HC
                          )}
                        >
                          <React.Fragment>
                            <span
                              className={
                                "plasmic_default__all plasmic_default__span"
                              }
                              style={{ textDecorationLine: "underline" }}
                            >
                              {"These are not personal failures."}
                            </span>
                          </React.Fragment>
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__vokdq
                          )}
                        >
                          {
                            "They\u2019re byproducts of systems that were never designed for the individual in the first place."
                          }
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__wa6ER
                          )}
                        >
                          {
                            "Our work isn\u2019t about being opposed to change or scale or existing systems or consolidating markets."
                          }
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__al3Pn
                          )}
                        >
                          {"Those are inevitable."}
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__nzi1
                          )}
                        >
                          <React.Fragment>
                            <React.Fragment>
                              {"Our response is about "}
                            </React.Fragment>
                            <span
                              className={
                                "plasmic_default__all plasmic_default__span"
                              }
                              style={{ textDecorationLine: "underline" }}
                            >
                              {"resisting erasure."}
                            </span>
                          </React.Fragment>
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__wi5Ye
                          )}
                        >
                          {"We didn\u2019t set out to change the world."}
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p___6R6St
                          )}
                        >
                          {
                            "But working inside the software chaos, we kept seeing the same pattern repeat."
                          }
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__rgbqw
                          )}
                        >
                          {"Everything is wired for quick wins at the surface."}
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__gO6F
                          )}
                        >
                          <React.Fragment>
                            <span
                              className={
                                "plasmic_default__all plasmic_default__span"
                              }
                              style={{ textDecorationLine: "underline" }}
                            >
                              {"Developers"}
                            </span>
                            <React.Fragment>
                              {
                                " have to ship yet another feature for yet another SaaS, app, or dashboard."
                              }
                            </React.Fragment>
                          </React.Fragment>
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__gZiiv
                          )}
                        >
                          <React.Fragment>
                            <span
                              className={
                                "plasmic_default__all plasmic_default__span"
                              }
                              style={{ textDecorationLine: "underline" }}
                            >
                              {"Business owners"}
                            </span>
                            <React.Fragment>
                              {
                                " have to stitch together tools, SaaS, ad platforms, and \u201cgrowth\u201d funnels\u2014patching dashboards, campaigns, and integrations just to keep the whole thing from falling apart."
                              }
                            </React.Fragment>
                          </React.Fragment>
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__nf6CE
                          )}
                        >
                          {
                            "If we\u2019re capable of designing and building at the foundation, why would we choose to stay at the surface, contributing to the noise?"
                          }
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__s08He
                          )}
                        >
                          {"We get it."}
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p___5WbIa
                          )}
                        >
                          {"It\u2019s familiar."}
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__ukjW9
                          )}
                        >
                          {"It pays fast."}
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__hikyt
                          )}
                        >
                          {"People understand what you\u2019re selling."}
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__mx6Xn
                          )}
                        >
                          {
                            "But the cost is a world where everyone is busy and dependent, and no one has the time or space to plan, build, or adapt for an uncertain future."
                          }
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__yUid9
                          )}
                        >
                          {
                            "Once we saw that the real problem sits in the foundation of how systems are built..."
                          }
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__tnn5V
                          )}
                        >
                          {
                            "It became hard to justify spending the next decade polishing band-aids."
                          }
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__tvmqp
                          )}
                        >
                          <React.Fragment>
                            <span
                              className={
                                "plasmic_default__all plasmic_default__span"
                              }
                              style={{ textDecorationLine: "underline" }}
                            >
                              {"What started as"}
                            </span>
                            <React.Fragment>
                              {
                                " two broke university students working on what was supposed to be a summer project..."
                              }
                            </React.Fragment>
                          </React.Fragment>
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__aqgaw
                          )}
                        >
                          {
                            "Became a mission to redesign the system-logic that\u2019s been shaping how society organizes work for the last century."
                          }
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__r3YbK
                          )}
                        >
                          {"Big words."}
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__hf9Ke
                          )}
                        >
                          {"I know."}
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p___7NB0K
                          )}
                        >
                          {
                            "But there isn\u2019t a smaller way to say it without lying."
                          }
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__g9Uma
                          )}
                        >
                          {"We\u2019re living through a real shift."}
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__qwdT8
                          )}
                        >
                          {
                            "A shift that opens the door to rebuild the foundation of modern systems with the individual at the center."
                          }
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__yUq1
                          )}
                        >
                          {"For the first time, it\u2019s becoming feasible..."}
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__akvUs
                          )}
                        >
                          {"And increasingly necessary..."}
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__j11G8
                          )}
                        >
                          {
                            "To reject the inherited digital infrastructure and build an alternative."
                          }
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__bpzD
                          )}
                        >
                          {
                            "The only way forward we see for bringing coherence to this..."
                          }
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p___6JkKz
                          )}
                        >
                          {"And making it sustainable for the individual..."}
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p___8VYoc
                          )}
                        >
                          {
                            "Is to redesign the system and its function so that it confers autonomy by design, instead of eroding it by default."
                          }
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__beu2K
                          )}
                        >
                          {"But."}
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p___3BXbx
                          )}
                        >
                          {"The inevitable \u201cbut.\u201d"}
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__rjtIn
                          )}
                        >
                          {
                            "That kind of infrastructure doesn\u2019t exist yet."
                          }
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__e52Of
                          )}
                        >
                          {
                            "And we\u2019re not going to pretend that having a basic understanding of systems theory and software development means we\u2019ve figured it all out."
                          }
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__tTgU
                          )}
                        >
                          {"We haven\u2019t."}
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__kpqr
                          )}
                        >
                          <React.Fragment>
                            <span
                              className={
                                "plasmic_default__all plasmic_default__span"
                              }
                              style={{ textDecorationLine: "underline" }}
                            >
                              {"Not even close."}
                            </span>
                          </React.Fragment>
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__ehOjl
                          )}
                        >
                          {"There\u2019s a lot more work to be done."}
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__kewwL
                          )}
                        >
                          {
                            "And here\u2019s where we extend an invitation to you."
                          }
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__gAdN
                          )}
                        >
                          {"Because here you are."}
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__oC6
                          )}
                        >
                          {"Look how deep you are on this page."}
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__nhL
                          )}
                        >
                          {
                            "You made it past the Jobs quote, a wall of text, and those one-word-plus-dot sentences..."
                          }
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__gheXm
                          )}
                        >
                          {"And you\u2019re still here."}
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__umUkX
                          )}
                        >
                          {"Putting that aside..."}
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p___9NWa9
                          )}
                        >
                          {"You can\u2019t deny that:"}
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p___7QfjL
                          )}
                        >
                          {
                            "What you\u2019ve found here so far puts words to a shift you already see and feel."
                          }
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__xJj6V
                          )}
                        >
                          {
                            "You\u2019ve watched people design their own way of working instead of climbing the old ladder."
                          }
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__kYrql
                          )}
                        >
                          {
                            "You\u2019ve seen one person with a laptop and the right tools do what used to take a whole team."
                          }
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__vliBe
                          )}
                        >
                          {
                            "You\u2019ve noticed how much boring work can now be handled in the background by systems."
                          }
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__ccUci
                          )}
                        >
                          {
                            "You\u2019ve felt your tolerance for \u201cjust play along and don\u2019t ask questions\u201d slowly drop."
                          }
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p___83Pa
                          )}
                        >
                          {"You know you can care about purpose and craft..."}
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__kl5Qv
                          )}
                        >
                          <React.Fragment>
                            <React.Fragment>
                              {
                                "...while rejecting blind growth and vanity metrics "
                              }
                            </React.Fragment>
                            <span
                              className={
                                "plasmic_default__all plasmic_default__span"
                              }
                              style={{ textDecorationLine: "underline" }}
                            >
                              {"without opting out of the modern world."}
                            </span>
                          </React.Fragment>
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__zM8PW
                          )}
                        >
                          {
                            "You\u2019d start redesigning the systems around you if you had the freedom and the right resources."
                          }
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__el0Qr
                          )}
                        >
                          {"And you know you\u2019re not the only one."}
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__j0Ua
                          )}
                        >
                          {
                            "You\u2019ve seen enough digital tools and interfaces to know they can be better\u2014and you\u2019d rather help build \u201cbetter\u201d than sit in the group that just complains."
                          }
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__nuQnI
                          )}
                        >
                          {
                            "Website copy can actually communicate something in a way a real human being would."
                          }
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__zyvkz
                          )}
                        >
                          {
                            "*that last one is with love for the marketing people*"
                          }
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__zdzBj
                          )}
                        >
                          {
                            "If you\u2019re still with me, here\u2019s who we are:"
                          }
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__b7UhF
                          )}
                        >
                          {"We are builders."}
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p___8QFxo
                          )}
                        >
                          {"We\u2019re creators."}
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__qjpXa
                          )}
                        >
                          {"We\u2019re early and hungry."}
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p___1MukT
                          )}
                        >
                          {
                            "We can be aggressively patient, knowing that our energy goes into something that actually matters."
                          }
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__uB8ER
                          )}
                        >
                          {
                            "We\u2019re not interested in spending the next decade squeezing a bit more efficiency out of broken systems."
                          }
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__n9JMd
                          )}
                        >
                          {"We\u2019re here to build the alternative."}
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__wpY6N
                          )}
                        >
                          {"I could go on."}
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__fjgM
                          )}
                        >
                          {"And on."}
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p___2RUZ
                          )}
                        >
                          {"And on."}
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__vp0Qf
                          )}
                        >
                          {"But I\u2019d rather hear your view on this shift:"}
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__jvAly
                          )}
                        >
                          {"Where you think it\u2019s going."}
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__imOkN
                          )}
                        >
                          {"What you believe needs to be built."}
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__krnlc
                          )}
                        >
                          <React.Fragment>
                            <span
                              className={
                                "plasmic_default__all plasmic_default__span"
                              }
                              style={{ textDecorationLine: "underline" }}
                            >
                              {"So I\u2019ll leave you with one question:"}
                            </span>
                          </React.Fragment>
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__sUrG1
                          )}
                        >
                          {
                            "Why wouldn\u2019t you join the o21p team and put your time and energy into helping the independent navigate the modern world without sacrificing their autonomy or compromising who they are, how they work, and what they stand for?"
                          }
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p___51V5
                          )}
                        >
                          {
                            "When you have your answer, don\u2019t keep it to yourself."
                          }
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__iBb0N
                          )}
                        >
                          {
                            "Send it to cristian@o21p.com, bypassing our big HR department."
                          }
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p___6CdrU
                          )}
                        >
                          {
                            "Once I\u2019m done with the Figma variables, I\u2019ll personally prepare the digital equivalent of a clean desk and an ergonomic chair for you\u2026"
                          }
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p___6Vdyk
                          )}
                        >
                          {
                            "Inside what can only be described as the UI version of a Scandinavian office."
                          }
                        </p>
                        <p
                          className={classNames(
                            projectcss.all,
                            projectcss.p,
                            projectcss.__wab_text,
                            sty.p__izgkS
                          )}
                        >
                          {"See you inside."}
                        </p>
                      </div>
                    }
                    width={"medium"}
                  />
                </section>
                <section
                  data-plasmic-name={"s999"}
                  data-plasmic-override={overrides.s999}
                  className={classNames(projectcss.all, sty.s999)}
                >
                  <Disclaimer
                    data-plasmic-name={"disclaimer"}
                    data-plasmic-override={overrides.disclaimer}
                    className={classNames("__wab_instance", sty.disclaimer)}
                  />

                  <Footer
                    data-plasmic-name={"footer"}
                    data-plasmic-override={overrides.footer}
                    className={classNames("__wab_instance", sty.footer)}
                    layout={"withOffset"}
                    sectionId={"footer"}
                  />
                </section>
              </React.Fragment>
            }
            layoutSections={"withNav"}
          />

          <div
            data-plasmic-name={"noBudgetSmallScreens"}
            data-plasmic-override={overrides.noBudgetSmallScreens}
            className={classNames(projectcss.all, sty.noBudgetSmallScreens)}
          >
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__uDiMl
              )}
            >
              {"o21p"}
            </div>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__jkO5D
              )}
            >
              {
                "our massive development budget is dedicated to designing and building the platform for larger screens."
              }
            </div>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__mUuOb
              )}
            >
              {"\u2013 at least 900px wide \u2013"}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  pageHome: [
    "pageHome",
    "sidebar",
    "pageLayout",
    "s00",
    "s1",
    "freeBox",
    "s999",
    "disclaimer",
    "footer",
    "noBudgetSmallScreens"
  ],

  sidebar: ["sidebar"],
  pageLayout: [
    "pageLayout",
    "s00",
    "s1",
    "freeBox",
    "s999",
    "disclaimer",
    "footer"
  ],

  s00: ["s00"],
  s1: ["s1", "freeBox"],
  freeBox: ["freeBox"],
  s999: ["s999", "disclaimer", "footer"],
  disclaimer: ["disclaimer"],
  footer: ["footer"],
  noBudgetSmallScreens: ["noBudgetSmallScreens"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicTeam__ArgProps,
          internalVariantPropNames: PlasmicTeam__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicTeam__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "pageHome") {
    func.displayName = "PlasmicTeam";
  } else {
    func.displayName = `PlasmicTeam.${nodeName}`;
  }
  return func;
}

export const PlasmicTeam = Object.assign(
  // Top-level PlasmicTeam renders the root element
  makeNodeComponent("pageHome"),
  {
    // Helper components rendering sub-elements
    sidebar: makeNodeComponent("sidebar"),
    pageLayout: makeNodeComponent("pageLayout"),
    s00: makeNodeComponent("s00"),
    s1: makeNodeComponent("s1"),
    freeBox: makeNodeComponent("freeBox"),
    s999: makeNodeComponent("s999"),
    disclaimer: makeNodeComponent("disclaimer"),
    footer: makeNodeComponent("footer"),
    noBudgetSmallScreens: makeNodeComponent("noBudgetSmallScreens"),
    // Metadata about props expected for PlasmicTeam
    internalVariantProps: PlasmicTeam__VariantProps,
    internalArgProps: PlasmicTeam__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "OP team.",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicTeam;
/* prettier-ignore-end */
